import React, { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router";
import { NavLink } from "react-router-dom";
import styled from "styled-components";
import { Layout, Menu, Popconfirm, Popover } from "antd";
import { MenuOutlined, UserOutlined } from "@ant-design/icons";
import { privateRoutes } from "../routes/routes";
import { useLogout } from "../recoil/auth";
const { Header, Content, Footer, Sider } = Layout;
const { SubMenu } = Menu;

const ServiceWrapper = ({ children }) => {
  const navigate = useNavigate();
  const logout = useLogout();
  const location = useLocation();
  const [url, setUrl] = useState("");
  const [menu, setMenu] = useState(true);
  const [showMenu, setShowMenu] = useState(false);
  const [privateRoute, setPrivateRoute] = useState(privateRoutes);
  const [isCollapsed, setIsCollapsed] = useState(false);
  const [isVisibleProfilePopover, setIsVisibleProfilePopover] = useState(false);

  const pathName = location.pathname;
  const rootPath = pathName.substring(0, pathName.indexOf("/", 2));
  const pathArray = pathName.split("/");

  const openKey = [];
  openKey[0] = pathArray.length > 2 ? rootPath : pathName;
  if (pathArray.length > 3) {
    openKey[1] = "/" + pathArray[1] + "/" + pathArray[2];
  }

  // 조직 권한에 따른 사이드바 라우트 필터링
  useEffect(() => {
    const org = sessionStorage.getItem("organization");
    const hasMegaInfo = org === "MEGAINFO";

    if (hasMegaInfo) {
      setPrivateRoute(privateRoutes);
    } else {
      const filtered = privateRoutes
        .filter((r) => r.isBranchVisible === true)
        .map((r) => ({
          ...r,
          children: Array.isArray(r.children)
            ? r.children.filter((c) => c.isBranchVisible === true)
            : r.children,
        }));
      setPrivateRoute(filtered);
    }
  }, [location.pathname]);

  useEffect(() => {
    if (window.innerWidth <= 960) {
      setMenu(false);
    }
  }, []);

  useEffect(() => {
    if (location.pathname !== url) {
      setUrl(url);
      setShowMenu(false);
    }
  }, [location.pathname]);

  return (
    <Layout>
      <Sider
        collapsed={isCollapsed}
        onCollapse={(collapsedState) => setIsCollapsed(collapsedState)}
        width={260}
        style={{
          overflow: "auto",
          height: "100vh",
          position: "fixed",
          left: 0,
          background: "white",
          borderRight: "1px solid #f0f0f0",
          display: menu ? "block" : showMenu ? "unset" : "none",
        }}
      >
        {!isCollapsed && (
          <LogoButton
            onClick={() => {
              navigate("/");
            }}
          >
            <LogoImage src={"/assets/images/logo.svg"} />
          </LogoButton>
        )}
        <StyledMenu
          mode="inline"
          activeKey={location.pathname}
          defaultOpenKeys={openKey}
          selectedKeys={[location.pathname]}
        >
          {privateRoute.map((parentRoute) =>
            parentRoute.children ? (
              <SubMenu
                key={parentRoute.path}
                icon={Object(parentRoute.sidebar).icon}
                title={Object(parentRoute.sidebar).label}
                style={{ fontSize: 14 }}
              >
                {parentRoute.children.map(({ visible = true, ...childrenRoute }) =>
                  childrenRoute?.sub ? (
                    <SubMenu
                      key={`${parentRoute.path}${childrenRoute.path}`}
                      title={Object(childrenRoute.sidebar).label}
                      style={{ fontSize: 14 }}
                    >
                      {childrenRoute.sub.map(
                        ({ visible = true, ...sub }) =>
                          visible && (
                            <Menu.Item
                              key={`${parentRoute.path}${childrenRoute.path}${sub.path}`}
                              icon={Object(sub.sidebar).icon}
                            >
                              <NavLink
                                to={`${parentRoute.path}${childrenRoute.path}${sub.path}`}
                                className="nav-text"
                                style={{ fontSize: 14 }}
                              >
                                {Object(sub.sidebar).label}
                              </NavLink>
                            </Menu.Item>
                          ),
                      )}
                    </SubMenu>
                  ) : (
                    visible && (
                      <Menu.Item
                        key={`${parentRoute.path}${childrenRoute.path}`}
                        icon={Object(childrenRoute.sidebar).icon}
                      >
                        <NavLink
                          to={`${parentRoute.path}${childrenRoute.path}`}
                          className="nav-text"
                          style={{ fontSize: 14 }}
                        >
                          {Object(childrenRoute.sidebar).label}
                        </NavLink>
                      </Menu.Item>
                    )
                  ),
                )}
              </SubMenu>
            ) : (
              <Menu.Item
                key={parentRoute.path}
                icon={Object(parentRoute.sidebar).icon}
              >
                <NavLink
                  to={parentRoute.path}
                  className="nav-text"
                  style={{ fontSize: 14 }}
                >
                  {Object(parentRoute.sidebar).label}
                </NavLink>
              </Menu.Item>
            ),
          )}
        </StyledMenu>
      </Sider>
      <Layout
        style={{
          marginLeft: isCollapsed ? 80 : 260,
          transition: "all 0.2s",
          minHeight: "100vh",
          backgroundColor: "white",
        }}
      >
        <Header
          style={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            padding: "0px 15px",
            backgroundColor: "white",
            boxShadow: "0 2px 8px #f0f1f2",
          }}
        >
          <MenuOutlined
            style={{ fontSize: 20 }}
            onClick={() => {
              if (!menu) {
                setShowMenu(!showMenu);
              } else {
                setIsCollapsed((prevState) => !prevState);
              }
            }}
          />
          <Popover
            trigger="click"
            placement="bottomRight"
            content={
              <>
                <PopoverContents>
                  <Popconfirm
                    title="로그아웃 하시겠습니까?"
                    onConfirm={logout}
                    okText="확인"
                    cancelText="취소"
                  >
                    <span style={{ color: "black", cursor: "pointer" }}>로그아웃</span>
                  </Popconfirm>
                </PopoverContents>
              </>
            }
            visible={isVisibleProfilePopover}
            onVisibleChange={(visibleState) => setIsVisibleProfilePopover(visibleState)}
          >
            <UserOutlined />
          </Popover>
        </Header>
        <Content style={{ overflow: "initial", background: "#FCFCFC" }}>
          {children}
        </Content>
        <Footer style={{ textAlign: "center", opacity: 0.3 }}>
          2025 Megainfo Management Consulting Group
        </Footer>
      </Layout>
    </Layout>
  );
};

const PopoverContents = styled.div`
  width: 150px;
`;

const LogoImage = styled.img`
  width: 100%;
  font-family: "Nanum Gothic", sans-serif;
  font-weight: 700;
  font-size: 24px;
  text-align: center;
  padding: 40px;
`;

const LogoButton = styled.button`
  background: none;
  border: none;
  cursor: pointer;
`;

const StyledMenu = styled(Menu)`
  /* 카테고리(SubMenu)만 활성화 색상 제거 */
  .ant-menu-submenu {
    .ant-menu-submenu-title {
      color: #000 !important;
      
      &:hover {
        color: #000 !important;
      }
      
      svg {
        color: #000 !important;
      }
    }
    
    &.ant-menu-submenu-open {
      .ant-menu-submenu-title {
        color: #000 !important;
        
        svg {
          color: #000 !important;
        }
      }
    }
    
    .ant-menu-submenu-arrow {
      color: #000 !important;
    }
  }
`;

export default ServiceWrapper;
